export const environment = {
  production: false,
  apiUrl: 'https://apidev.ugchub.ru/v1',
  imgUrlStorage: 'https://apidev.ugchub.ru/storage/',
  imgUrlStorageMessage: 'https://apidev.ugchub.ru/',
  webSocket: 'wss://wsdev.ugchub.ru',
  yandexMapsApiKey: 'dbe9e598-d392-4e4c-b7e7-fb94be4347da',
};
